import { render, staticRenderFns } from "./registeradmin.vue?vue&type=template&id=32883b69&scoped=true"
import script from "./registeradmin.vue?vue&type=script&lang=js"
export * from "./registeradmin.vue?vue&type=script&lang=js"
import style0 from "./registeradmin.vue?vue&type=style&index=0&id=32883b69&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32883b69",
  null
  
)

export default component.exports